import React from 'react';
import { useAuth } from '../hooks/useAuth';
import LanguageSelector from './LanguageSelector';

const GlobalHeader: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <header className="bg-gray-900 border-b border-gray-800 px-6 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <h1 className="text-xl font-bold text-white">Comex</h1>
          {user && (
            <span className="text-sm text-gray-400">
              Welcome, {user.name}
            </span>
          )}
        </div>
        
        <div className="flex items-center space-x-4">
          <LanguageSelector />
          
          {user && (
            <div className="flex items-center space-x-3">
              <span className="text-sm text-gray-300 capitalize">
                {user.role}
              </span>
              <button
                onClick={logout}
                className="px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default GlobalHeader;
